import React from "react";

import {observer} from "mobx-react";
import {NewSearchWidgetSportsFilterList} from "./new-search-widget.sports-filter.list";
import {NewSearchWidgetSportsFilterHeader} from "./new-search-widget.sports-filter.header";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";

export const NewSearchWidgetSportsFilter = observer(({controller}) => {
  const {state: {isSportTypeMenuOpen}} = controller;

  const baseProps = {
    controller,
    onClick : () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSportTypeMenuClick, {isOpen: !isSportTypeMenuOpen})
  }

  return (
    <>
      <NewSearchWidgetSportsFilterHeader {...baseProps}/>
      <NewSearchWidgetSportsFilterList {...baseProps}/>
    </>
  )
});
